/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {
  useGroupAssignmentChooser,
  UseGroupAssignmentChooserProps,
  UseGroupAssignmentChooserResult
} from './useGroupAssignmentChooser';

/**
 * Hook for managing group assignment container.
 */
export const useGroupAssignment = ({
  setTaskNickNameAction
}: UseGroupAssignmentChooserProps): UseGroupAssignmentChooserResult => {
  const {
    groupAction,
    handleActionChooser,
    isNewGroup,
    setReplaceGroups,
    replaceGroups,
    handleRemoveGroupChooser,
    handleFromGroupChooser,
    fromGroup,
    toGroup,
    handleAccountGroupChooser,
    handleGroupChooser,
    isGroupNameEmpty,
    isGroupNameExists,
    groupName,
    setNoGroups,
    noGroups,
    setShowGroupsError,
    showGroupsError,
    setFormState,
    formState,
    fromAccount,
    handleGroupNameChooser,
    handleGroupNotesChooser,
    setIsGroupEmpty,
    isGroupEmpty,
    setIsFromGroupEmpty,
    isFromGroupEmpty
  } = useGroupAssignmentChooser({setTaskNickNameAction});
  
  return {
    groupAction,
    handleActionChooser,
    isNewGroup,
    setReplaceGroups,
    replaceGroups,
    handleRemoveGroupChooser,
    handleFromGroupChooser,
    fromGroup,
    toGroup,
    handleAccountGroupChooser,
    handleGroupChooser,
    isGroupNameEmpty,
    isGroupNameExists,
    groupName,
    setNoGroups,
    noGroups,
    setShowGroupsError,
    showGroupsError,
    setFormState,
    formState,
    fromAccount,
    handleGroupNameChooser,
    handleGroupNotesChooser,
    setIsGroupEmpty,
    isGroupEmpty,
    setIsFromGroupEmpty,
    isFromGroupEmpty
  };
};

export default useGroupAssignment;
